module.exports = __webpack_public_path__ + "ca8e1154a5fdcf843ee445a6fd8e707b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/sports-clubhouse-empty.png
// module id = 344
// module chunks = 0